import React, { useState, useEffect, useCallback } from 'react'
import { Container, Table, Button, Modal, Form, Tabs, Tab } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import axios from 'axios'
import V2Layout from '../components/V2Layout'
import './Admin.css'

const API = ''

const CAPABILITIES = [
    { slug: 'valve-design', label: 'Valve Design' },
    { slug: 'machining', label: 'Machining' },
    { slug: 'cleaning', label: 'Cleaning & Passivation' },
    { slug: 'assembly-test', label: 'Assembly & Test' },
    { slug: 'environmental-testing', label: 'Environmental Testing' },
    { slug: 'contract-manufacturing', label: 'Customer IP Components' },
    { slug: 'quality', label: 'Quality' },
    { slug: 'facility-v2', label: 'Facility V2' },
    { slug: 'about-facility', label: 'About - Our Facility' }
]

const CapabilitiesAdminScreen = () => {
    const [activeTab, setActiveTab] = useState('valve-design')
    const [sections, setSections] = useState([])
    const [loading, setLoading] = useState(true)
    const [showModal, setShowModal] = useState(false)
    const [editSection, setEditSection] = useState(null)
    const [form, setForm] = useState({ title: '', body: '', image_path: '', sort_order: 0 })
    const [uploading, setUploading] = useState(false)
    const [showDelete, setShowDelete] = useState(false)
    const [deleteTarget, setDeleteTarget] = useState(null)

    const fetchSections = useCallback((slug) => {
        setLoading(true)
        axios.get(`${API}/api/capabilities/${slug}/sections`)
            .then(res => {
                setSections(res.data)
                setLoading(false)
            })
            .catch(err => {
                console.error(`Error loading capabilities sections for ${slug}:`, err)
                setLoading(false)
            })
    }, [])

    useEffect(() => {
        fetchSections(activeTab)
    }, [activeTab, fetchSections])

    const openAdd = () => {
        setEditSection(null)
        setForm({ title: '', body: '', image_path: '', sort_order: sections.length })
        setShowModal(true)
    }

    const openEdit = (section) => {
        setEditSection(section)
        setForm({
            title: section.title,
            body: section.body,
            image_path: section.image_path || '',
            sort_order: section.sort_order
        })
        setShowModal(true)
    }

    const handleUpload = async (e) => {
        const file = e.target.files[0]
        if (!file) return
        setUploading(true)
        const formData = new FormData()
        formData.append('image', file)
        try {
            const res = await axios.post(`${API}/api/capabilities/upload`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            setForm(prev => ({ ...prev, image_path: res.data.url }))
        } catch (err) {
            console.error('Upload failed:', err)
            alert('Image upload failed.')
        } finally {
            setUploading(false)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            if (editSection) {
                await axios.put(`${API}/api/capabilities/sections/${editSection.id}`, form)
            } else {
                await axios.post(`${API}/api/capabilities/${activeTab}/sections`, form)
            }
            setShowModal(false)
            fetchSections(activeTab)
        } catch (err) {
            console.error('Error saving section:', err)
            alert('Failed to save section.')
        }
    }

    const confirmDelete = async () => {
        if (!deleteTarget) return
        try {
            await axios.delete(`${API}/api/capabilities/sections/${deleteTarget.id}`)
            setShowDelete(false)
            fetchSections(activeTab)
        } catch (err) {
            console.error('Error deleting section:', err)
            alert('Failed to delete section.')
        }
    }

    return (
        <V2Layout pageClass="pfc-admin">
            <style>{`
                .pfc-admin-container {
                    padding: 3rem 0 5rem;
                    background-color: #faf9f6;
                    min-height: 80vh;
                }
                .pfc-admin-card {
                    background: #fff;
                    border: 1px solid #e5e3dd;
                    border-radius: 8px;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
                    padding: 32px;
                    margin-bottom: 24px;
                }
                .pfc-admin-tabs.nav-pills {
                    border-bottom: 1px solid #e5e3dd;
                    padding-bottom: 12px;
                    margin-bottom: 24px;
                }
                .pfc-admin-tabs.nav-pills .nav-link {
                    font-family: var(--pfc-mono, monospace);
                    font-size: 13px;
                    font-weight: 600;
                    color: #5F5E5A;
                    background: none;
                    border: 1px solid transparent;
                    padding: 8px 16px;
                    border-radius: 4px;
                    transition: all 0.2s ease;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                }
                .pfc-admin-tabs.nav-pills .nav-link:hover {
                    color: #26215C;
                    background-color: rgba(38, 33, 148, 0.04);
                }
                .pfc-admin-tabs.nav-pills .nav-link.active {
                    color: #fff !important;
                    background-color: #26215C !important;
                    box-shadow: 0 4px 12px rgba(38, 33, 92, 0.2);
                }
                .pfc-admin-table {
                    border-collapse: separate;
                    border-spacing: 0;
                    border: 1px solid #e5e3dd;
                    border-radius: 6px;
                    overflow: hidden;
                    background-color: #fff;
                    margin-top: 1.5rem;
                }
                .pfc-admin-table thead th {
                    background-color: #26215C !important;
                    color: #fff !important;
                    font-family: var(--pfc-mono, monospace);
                    font-size: 11px;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    font-weight: 600;
                    border: none;
                    padding: 12px 16px;
                }
                .pfc-admin-table tbody td {
                    padding: 12px 16px;
                    vertical-align: middle;
                    font-size: 14px;
                    color: #333;
                    border-bottom: 1px solid #f1efe8;
                }
                .pfc-admin-table tbody tr:last-child td {
                    border-bottom: none;
                }
                .pfc-admin-table tbody tr {
                    transition: background-color 0.15s ease;
                }
                .pfc-admin-table tbody tr:hover {
                    background-color: rgba(38, 33, 148, 0.01) !important;
                }
                .btn-pfc-primary {
                    background-color: #26215C !important;
                    border-color: #26215C !important;
                    color: #fff !important;
                    font-family: var(--pfc-mono, monospace);
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    padding: 8px 16px;
                    border-radius: 4px;
                    font-weight: 600;
                    transition: all 0.2s ease;
                }
                .btn-pfc-primary:hover, .btn-pfc-primary:focus {
                    background-color: #1a1645 !important;
                    border-color: #1a1645 !important;
                    color: #fff !important;
                    box-shadow: 0 4px 12px rgba(38, 33, 92, 0.15);
                }
                .btn-pfc-secondary {
                    background-color: #fff !important;
                    border-color: #ced4da !important;
                    color: #5c5a54 !important;
                    font-family: var(--pfc-mono, monospace);
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    padding: 8px 16px;
                    border-radius: 4px;
                    font-weight: 600;
                    transition: all 0.2s ease;
                }
                .btn-pfc-secondary:hover {
                    background-color: #faf9f6 !important;
                    border-color: #adb5bd !important;
                    color: #333 !important;
                }
            `}</style>

            <section className="pfc-admin-container">
                <Container>
                    <div className="pfc-admin-card">
                        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                            <div>
                                <h1 style={{ color: '#26215C', fontSize: '2rem', margin: 0, fontWeight: 700 }}>Capabilities Admin</h1>
                                <p className="text-muted mb-0 mt-1" style={{ fontSize: '13px' }}>
                                    Manage custom alternating visual sections displayed on each of the Capabilities pages.
                                </p>
                            </div>
                            <Button className="btn-pfc-primary" onClick={openAdd}>
                                + Add Section
                            </Button>
                        </div>

                        {/* Top sub-navigation bar */}
                        <div className="d-flex gap-3 mb-4 align-items-center pfc-admin-subnav">
                            <Link to="/admin" className="pfc-admin-subnav-link">Dashboard</Link>
                            <span className="pfc-admin-subnav-sep">|</span>
                            <Link to="/products/admin" className="pfc-admin-subnav-link">Products Admin</Link>
                            <span className="pfc-admin-subnav-sep">|</span>
                            <Link to="/capabilities/admin" className="pfc-admin-subnav-link active">Capabilities Admin</Link>
                            <span className="pfc-admin-subnav-sep">|</span>
                            <Link to="/news/admin" className="pfc-admin-subnav-link">News Admin</Link>
                            <span className="pfc-admin-subnav-sep">|</span>
                            <Link to="/story/admin" className="pfc-admin-subnav-link">Timeline Admin</Link>
                            <span className="pfc-admin-subnav-sep">|</span>
                            <Link to="/certifications/admin" className="pfc-admin-subnav-link">Certifications Admin</Link>
                        </div>

                        <Tabs activeKey={activeTab} onSelect={setActiveTab} className="mb-3 pfc-admin-tabs" variant="pills">
                            {CAPABILITIES.map(cap => (
                                <Tab key={cap.slug} eventKey={cap.slug} title={cap.label}>
                                    {loading ? (
                                        <div className="text-center py-5 text-muted" style={{ fontStyle: 'italic' }}>
                                            Loading capability sections...
                                        </div>
                                    ) : sections.length === 0 ? (
                                        <div className="text-center py-5 text-muted" style={{ fontStyle: 'italic' }}>
                                            No sections configured for this page. Click "+ Add Section" to create one.
                                        </div>
                                    ) : (
                                        <Table bordered hover responsive className="pfc-admin-table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '80px' }}>Sort</th>
                                                    <th style={{ width: '120px' }}>Image</th>
                                                    <th style={{ width: '250px' }}>Title</th>
                                                    <th>Description</th>
                                                    <th style={{ width: '150px' }}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {sections.map(sec => (
                                                    <tr key={sec.id}>
                                                        <td style={{ fontFamily: 'var(--pfc-mono, monospace)', fontWeight: 600 }}>{sec.sort_order}</td>
                                                        <td>
                                                            {sec.image_path ? (
                                                                <img 
                                                                    src={`${API}${sec.image_path}`} 
                                                                    alt={sec.title} 
                                                                    style={{ width: '80px', height: '50px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #e5e3dd' }} 
                                                                />
                                                            ) : (
                                                                <span style={{ fontSize: '11px', color: '#8a85a0', fontStyle: 'italic' }}>No Image</span>
                                                            )}
                                                        </td>
                                                        <td style={{ fontWeight: 600, color: '#26215C' }}>{sec.title}</td>
                                                        <td style={{ fontSize: '13px', color: '#666', lineHeight: 1.4 }}>{sec.body}</td>
                                                        <td>
                                                            <Button 
                                                                size="sm" 
                                                                variant="outline-primary" 
                                                                onClick={() => openEdit(sec)} 
                                                                className="me-2" 
                                                                style={{ fontSize: '11px' }}
                                                            >
                                                                Edit
                                                            </Button>
                                                            <Button 
                                                                size="sm" 
                                                                variant="outline-danger" 
                                                                onClick={() => { setDeleteTarget(sec); setShowDelete(true) }} 
                                                                style={{ fontSize: '11px' }}
                                                            >
                                                                Del
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    )}
                                </Tab>
                            ))}
                        </Tabs>
                    </div>
                </Container>
            </section>

            {/* ── Add / Edit Modal ── */}
            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: '#26215C', fontWeight: 700 }}>
                            {editSection ? 'Edit Section' : 'Add Section'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label style={{ fontWeight: 600 }}>Title</Form.Label>
                            <Form.Control 
                                type="text" 
                                required 
                                value={form.title} 
                                onChange={e => setForm({ ...form, title: e.target.value })} 
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label style={{ fontWeight: 600 }}>Description / Body Text</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={4} 
                                value={form.body} 
                                onChange={e => setForm({ ...form, body: e.target.value })} 
                            />
                        </Form.Group>
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label style={{ fontWeight: 600 }}>Sort Order</Form.Label>
                                    <Form.Control 
                                        type="number" 
                                        required 
                                        value={form.sort_order} 
                                        onChange={e => setForm({ ...form, sort_order: +e.target.value })} 
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label style={{ fontWeight: 600 }}>Section Image</Form.Label>
                                    <Form.Control 
                                        type="file" 
                                        accept="image/*"
                                        onChange={handleUpload} 
                                    />
                                    {uploading && <Form.Text className="text-primary">Uploading image...</Form.Text>}
                                    {form.image_path && !uploading && (
                                        <div className="mt-2 d-flex align-items-center justify-content-between p-2" style={{ backgroundColor: '#f4f3f8', borderRadius: '4px', border: '1px solid #e5e3dd' }}>
                                            <span style={{ fontSize: '11px', color: '#666', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '80%' }}>
                                                {form.image_path.split('/').pop()}
                                            </span>
                                            <Button 
                                                size="sm" 
                                                variant="link" 
                                                onClick={() => setForm({ ...form, image_path: '' })}
                                                className="text-danger p-0 ms-2"
                                                style={{ fontSize: '11px', textDecoration: 'none' }}
                                            >
                                                Remove
                                            </Button>
                                        </div>
                                    )}
                                </Form.Group>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn-pfc-secondary" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                        <Button type="submit" className="btn-pfc-primary" disabled={uploading}>
                            Save Section
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* ── Delete Modal ── */}
            <Modal show={showDelete} onHide={() => setShowDelete(false)} centered size="sm">
                <Modal.Header closeButton>
                    <Modal.Title style={{ color: '#993C1D', fontWeight: 700, fontSize: '1.2rem' }}>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ fontSize: '13px' }}>
                    Are you sure you want to delete section <strong>{deleteTarget?.title}</strong>? This action cannot be undone.
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn-pfc-secondary" size="sm" onClick={() => setShowDelete(false)}>Cancel</Button>
                    <Button variant="danger" size="sm" style={{ fontFamily: 'var(--pfc-mono, monospace)', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.05em', padding: '8px 16px' }} onClick={confirmDelete}>Delete</Button>
                </Modal.Footer>
            </Modal>
        </V2Layout>
    )
}

export default CapabilitiesAdminScreen
